const floors = [{
    label: "1",
    value: 1
}, {
    label: "2",
    value: 2
}, {
    label: "3",
    value: 3
}, {
    label: "4",
    value: 4
}, {
    label: "5",
    value: 5
}]
const bedrooms = [{
    label: "1",
    value: 1
}, {
    label: "2",
    value: 2
}, {
    label: "3",
    value: 3
}, {
    label: "4",
    value: 4
}, {
    label: "5",
    value: 5
}]
const bathrooms = [{
    label: "1",
    value: 1
}, {
    label: "2",
    value: 2
}, {
    label: "3",
    value: 3
}]
const years = [{
    label: "1",
    value: 1
}, {
    label: "2",
    value: 2
}, {
    label: "3",
    value: 3
}, {
    label: "4",
    value: 4
}, {
    label: "5",
    value: 5
}]
const payment_methods = [{
    label: "Cash",
    value: "Cash"
}, {
    label: "Installment",
    value: "Installment"
}]
const resalePayment_methods = [{
    label: "Cash",
    value: "Cash"
}, {
    label: "Installment",
    value: "Installment"
}, {
    label: "Installment with Owner",
    value: "Owner Installment"
}
]
const installment_type = [
    {label: "Equal Payments", value: 'equal'},
    {label: "Variable Payments", value: 'variable'},
]

const Gogovernorates = [{
    label: "Cairo",
    en:"Cairo",
    ar:"القاهرة",
    zh:"开罗",
    ru:"Каир",
    value: "Cairo"
},{
    label: "Alexandria",
    en:"Alexandria",
    ar:"الاسكندرية",
    zh:"亚历山大港",
    ru:"Александрия",
    value: "Alexandria",

}, {
    label: "Giza",
    en:"Giza",
    ar:"الجيزة",
    zh:"吉萨",
    ru:"Человек",
    value: "Giza"
},{
    label: "Qalyubiya",
    en:"Qalyubiya",
    ar:"القليوبية",
    zh:"加柳比亚",
    ru:"Каллюбия",
    value: "Qalyubiya"
},{
    label: "Dakahlia",
    en:"Dakahlia",
    ar:"الدقهلية",
    zh:"达卡利亚",
    ru:"Дакахлия",
    value: "Dakahlia"
},{
    label: "Sharqiyah",
    en:"Sharqiyah",
    ar:"الشرقية",
    zh:"东",
    ru:"Восточный",
    value: "Sharqiyah"
},{
    label: "Menoufia",
    en:"Menoufia",
    ar:"المنوفية",
    zh:"门诺菲亚",
    ru:"Менуфия",
    value: "Menoufia"
},{
    label: "Gharbiya",
    en:"Gharbiya",
    ar:"الغربية",
    zh:"西",
    ru:"вестерн",
    value: "Gharbiya"
},{
    label: "Behira",
    en:"Behira",
    ar:"البحيرة",
    zh:"那个湖",
    ru:"Озеро",
    value: "Behira"
},{
    label: "Port Said",
    en:"Port Said",
    ar:"بورسعيد",
    zh:"塞得港",
    ru:"Порт-Саид",
    value: "Port Said"
},{
    label: "Damietta",
    en:"Damietta",
    ar:"دمياط",
    zh:"达米埃塔",
    ru:"Дамиетта",
    value: "Damietta"
},{
    label: "Ismailia",
    en:"Ismailia",
    ar:"الاسماعيلية",
    zh:"伊斯梅利亚",
    ru:"Исмаилия",
    value: "Ismailia"
},{
    label: "Suez",
    en:"Suez",
    ar:"السويس",
    zh:"苏伊士",
    ru:"Суэц",
    value: "Suez"
},{
    label: "Kafr El-Sheikh",
    en:"Kafr El-Sheikh",
    ar:"كفر الشيخ",
    zh:"卡夫尔谢赫",
    ru:"Кафр Эль-Шейх",
    value: "Kafr El-Sheikh"
},{
    label: "Marsa Matrouh",
    en:"Marsa Matrouh",
    ar:"مرسى مطروح",
    zh:"玛莎·马特鲁",
    ru:"Марса Матрух",
    value: "Marsa Matrouh"
},{
    label: "North Sinai",
    en:"North Sinai",
    ar:"شمال سيناء",
    zh:"北西奈",
    ru:"Северный Синай",
    value: "North Sinai"
},{
    label: "South Sinai",
    en:"South Sinai",
    ar:"جنوب سيناء",
    zh:"锡那南部",
    ru:"к югу от Синаа",
    value: "South Sinai"
},{
    label: "Bani Sweif",
    en:"Bani Sweif",
    ar:"بنى سويف",
    zh:"巴尼·斯威夫",
    ru:"Бани Свайф",
    value: "Bani Sweif"
},{
    label: "Fayoum",
    en:"Fayoum",
    ar:"الفيوم",
    zh:"法尤姆",
    ru:"Фаюм",
    value: "Fayoum"
},{
    label: "Minya",
    en:"Minya",
    ar:"المنيا",
    zh:"明雅",
    ru:"Минья",
    value: "Minya"
},{
    label: "Assiut",
    en:"Assiut",
    ar:"اسيوط",
    zh:"阿育特",
    ru:"Асьют",
    value: "Assiut"
},{
    label: "Sohag",
    en:"Sohag",
    ar:"سوهاج",
    zh:"索哈格",
    ru:"Сохаг",
    value: "Sohag"
},{
    label: "Qena",
    en:"Qena",
    ar:"قنا",
    zh:"奇娜",
    ru:"кана",
    value: "Qena"
},{
    label: "luxor",
    en:"luxor",
    ar:"الاقصر",
    zh:"卢克索",
    ru:"кратчайший",
    value: "luxor"
},{
    label: "Red Sea",
    en:"Red Sea",
    ar:"البحر الأحمر",
    zh:"红海",
    ru:"Красное море",
    value: "Red Sea"
},{
    label: "Wadi al-Jadid",
    en:"Wadi al-Jadid",
    ar:"الوادى الجديد",
    zh:"新山谷",
    ru:"новая долина",
    value: "Wadi al-Jadid"
},{
    label: "Aswan",
    en:"Aswan",
    ar:"أسوان",
    zh:"阿斯旺",
    ru:"Асуан",
    value: "Aswan"
}]
 

const facingPlaces = [{
    label: "Main street",
    en:"Main street",
    ar:"شارع رئيسى",
    zh:"主要街道",
    ru:"Главная улица",
    value: "Main street"
}, {
    label: "Side street",
    en:"Side street",
    ar:"شارع جانيى",
    zh:"小街",
    ru:"Боковая улица",
    value: "Side street"
}, {
    label: "Landscape",
    en:"Landscape",
    ar:"منظر جمالي",
    zh:"景观",
    ru:"Пейзаж",
    value: "Landscape"
},

]
const furnishing = [{
    label: "Unfurnished",
    en:"Unfurnished",
    ar:"غير مفروش",
    zh:"无家具",
    ru:"Без мебели",
    value: "Unfurnished"
}, {
    label: "Furnished",
    en:"Furnished",
    ar:"مفروش",
    zh:"带家具的",
    ru:"Меблированный",
    value: "Furnished"
}]

const frequencyOwnerOptions=[
    {
        label: "One Shot",
        en:"One Shot",
        ar:"مره واحده",
        zh:"一枪",
        ru:"Один выстрел",
        value: "One Shot"
    },
    {
        label: "Monthly",
        en:"Monthly",
        ar:"شهريا",
        zh:"月刊",
        ru:"Ежемесячно",
        value: "Monthly"
    }, {
        label: "Quarterly",
        en:"Quarterly",
        ar:"ربع سنوى",
        zh:"季刊",
        ru:"Ежеквартальный",
        value: "Quarterly"
    }, {
        label: "Semi-Annual",
        en:"Semi-Annual",
        ar:"نصف سنوي",
        zh:"半年",
        ru:"Полугодовой",
        value: "Semi-Annual"
    }, {
        label: "Annual",
        en:"Annual",
        ar:"سنوى",
        zh:"年度的",
        ru:"Ежегодный",
        value: "Annual"
    }
]
const frequencyPropertyOptions=[
    {
        label: "Monthly",
        en:"Monthly",
        ar:"شهريا",
        zh:"月刊",
        ru:"Ежемесячно",
        value: "Monthly"
    }, {
        label: "Quarterly",
        en:"Quarterly",
        ar:"ربع سنوى",
        zh:"季刊",
        ru:"Ежеквартальный",
        value: "Quarterly"
    }, {
        label: "Semi-Annual",
        en:"Semi-Annual",
        ar:"نصف سنوي",
        zh:"半年",
        ru:"Полугодовой",
        value: "Semi-Annual"
    }, {
        label: "Annual",
        en:"Annual",
        ar:"سنوى",
        zh:"年度的",
        ru:"Ежегодный",
        value: "Annual"
    }
]
const frequencyOptions = [{
    label: "Monthly",
    en:"Monthly",
    ar:"شهريا",
    zh:"月刊",
    ru:"Ежемесячно",
    value: "Monthly"
}, {
    label: "Quarterly",
    en:"Quarterly",
    ar:"ربع سنوى",
    zh:"季刊",
    ru:"Ежеквартальный",
    value: "Quarterly"
}
]

const frequencyTypeOptions=[{
    label: "Unit",
    en:"Unit",
    ar:"الوحدة",
    zh:"月刊",
    ru:"Ед. изм",
    value: "Unit"
}, {
    label: "Parking",
    en:"Parking",
    ar:"الجراج",
    zh:"停車處",
    ru:"Паркінг",
    value: "Parking"
},{
    label: "Clubhouse",
    en:"Clubhouse",
    ar:"النادى",
    zh:"俱乐部",
    ru:"Клуб",
    value: "Clubhouse"
},{
    label: "Maintenance",
    en:"Maintenance",
    ar:"الصيانة",
    zh:"维护",
    ru:"Технічне обслуговування",
    value: "Maintenance"
}]
const offPaymentTypeOptions=[{
    label: "Parking",
    en:"Parking",
    ar:"الجراج",
    zh:"停車處",
    ru:"Паркінг",
    value: "Parking"
},{
    label: "Clubhouse",
    en:"Clubhouse",
    ar:"النادى",
    zh:"俱乐部",
    ru:"Клуб",
    value: "Clubhouse"
},{
    label: "Maintenance",
    en:"Maintenance",
    ar:"الصيانة",
    zh:"维护",
    ru:"Технічне обслуговування",
    value: "Maintenance"
}]
const amenitiesOptions=[
    {
    label: "Basement",
    en:"Basement",
    ar:"",
    zh:"",
    ru:"",
    value: "Basement"
    }, {
        label: "Swimming Pool",
        en:"Swimming Pool",
        ar:"حمام السباحة",
        zh:"游泳池",
        ru:"Бассейн",
        value: "Swimming Pool"
    }, {
        label: "Parking",
        en:"Parking",
        ar:"",
        zh:"",
        ru:"",
        value: "Parking"
    }, {
        label: "Air Condition",
        en:"Air Condition",
        ar:"",
        zh:"",
        ru:"",
        value: "Air Condition"
    },{
        label: "Kitchen Cabins",
        en:"Kitchen Cabins",
        ar:"كبائن المطبخ",
        zh:"厨房小屋",
        ru:"Кухонные кабины",
        value: "Kitchen Cabins"
    },{
        label: "Shutters",
        en:"Shutters",
        ar:"النافذة",
        zh:"百叶窗",
        ru:"Ставни",
        value: "Shutters"
    },{
        label: "Appliances",
        en:"Appliances",
        ar:"",
        zh:"",
        ru:"",
        value: "Appliances"
    },{
        label: "Pergola",
        en:"Pergola",
        ar:"عريشة",
        zh:"凉棚",
        ru:"Пергола",
        value: "Pergola"
    },{
        label: "Multi floors",
        en:"Multi floors",
        ar:"",
        zh:"",
        ru:"",
        value: "Multi floors"
    }
]
const adminAmenitiesOptions=[
    {
    label: "Basement",
    en:"Basement",
    ar:"",
    zh:"",
    ru:"",
    value: "Basement"
    }, {
        label: "Swimming Pool",
        en:"Swimming Pool",
        ar:"حمام السباحة",
        zh:"游泳池",
        ru:"Бассейн",
        value: "Swimming Pool"
    }, {
        label: "Parking",
        en:"Parking",
        ar:"",
        zh:"",
        ru:"",
        value: "Parking"
    }, {
        label: "Air Condition",
        en:"Air Condition",
        ar:"",
        zh:"",
        ru:"",
        value: "Air Condition"
    },{
        label: "Kitchen Cabins",
        en:"Kitchen Cabins",
        ar:"كبائن المطبخ",
        zh:"厨房小屋",
        ru:"Кухонные кабины",
        value: "Kitchen Cabins"
    },{
        label: "Shutters",
        en:"Shutters",
        ar:"النافذة",
        zh:"百叶窗",
        ru:"Ставни",
        value: "Shutters"
    },{
        label: "Appliances",
        en:"Appliances",
        ar:"",
        zh:"",
        ru:"",
        value: "Appliances"
    },{
        label: "Pergola",
        en:"Pergola",
        ar:"عريشة",
        zh:"凉棚",
        ru:"Пергола",
        value: "Pergola"
    },{
        label: "Multi floors",
        en:"Multi floors",
        ar:"",
        zh:"",
        ru:"",
        value: "Multi floors"
    }
]

const activityOptions = [{
    label: "Call",
    value: "Call",
}, {
    label: "Meeting",
    value: "Meeting",
}, {
    label: "Visit",
    value: "Visit"
}]
const type_of_paid_options = [
    {label: 'Amount', value: 'amount'},
    {label: 'Percentage', value: 'percentage'},
    {label: 'Amount per meter', value: 'amount_per_meter'},
    {label: 'Percentage per meter', value: 'percentage_per_meter'}
]
const paymentOptions = [{
    en: "Cash",
    ar: "نقدى",
    ru:"Наличные",
    zh:"现金",
}, {
    en: "Installment",
    ar: "تقسيط",
    ru:"Рассрочка",
    zh:"分期付款",
}, {
    en: "Owner Installment",
    ar: "تقسيط مع المالك",
    ru:"Рассрочка владельца",
    zh:"业主分期付款",
}]
const unitTypeOptions = [
    {label: 'Property in Compound', value: 'Property in Compound'}, 
    {label: 'Resale in Compound', value: 'Resale in Compound'}, 
    {label: 'Resale Unit Outside Compound', value: 'Resale Unit Outside Compound'},
    {label: 'Other', value: 'Other'}
]

const unitPropertyOptions=[
    {label: "Unit Code", value: "name"},
    {label: "Unit Floor", value: "floor"},
    {label: "Numbers of Unit Bedrooms", value: "bedrooms"},
    {label: "Numbers of Unit Bathrooms", value: "bathrooms"},
    {label: "price", value: "price"},
    {label: "description", value: "description"},
    {label: "status", value: "status"},
    {label: "Building Code", value: "building_id"},
    {label: "Category Name", value: "category_id"},
    {label: "Finishing Type", value: "finishing_type_id"},
    {label: "Unit Type", value: "unit_type_id"},
]

export { paymentOptions,amenitiesOptions, adminAmenitiesOptions,
    frequencyTypeOptions, offPaymentTypeOptions ,installment_type,
    activityOptions, frequencyPropertyOptions,floors, 
    bathrooms, bedrooms, years, payment_methods, 
    Gogovernorates, resalePayment_methods, type_of_paid_options,
    frequencyOptions,frequencyOwnerOptions, unitPropertyOptions,
    facingPlaces, furnishing, unitTypeOptions }